export const getFileNameFromUrl = (path: string) => {
  // If it's already just a filename (no slashes), return it as is
  if (!path?.includes("/")) {
    return path;
  }

  // Otherwise, try to extract from URL
  const regex = /\/([^\/]+)$/; // Matches the last part after the last '/'
  const match = path.match(regex);

  if (match && match.length > 1) {
    return match[1];
  }

  return "N/A";
};

export const getFileExtensionFromUrl = (url: string) => {
  return url?.split(".").pop() || "";
};
